import app from "../../Firebase";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import React, { useEffect, useState } from 'react';
import Constant from "../Utils/Constant";
import axios from "axios";
import { toast } from "react-toastify";

const EditHelpForm = ({ editPopup, setEditPopup }) => {

  const [client_name, setClient_name] = useState(editPopup.client_name || "");
  const [choose_file, setChoose_file] = useState(undefined);
  const [web_link, setWeb_link] = useState(editPopup.web_link || "");
  const [inputs, setInputs] = useState({});
  const [choose_filePerc, setChoose_filePerc] = useState(0);
  const data = editPopup;

  // upload choose file started
  useEffect(() => {
    choose_file && uploadFile(choose_file, "choose_fileUrl");
  }, [choose_file]);

  const uploadFile = (file, fileType) => {
    const storage = getStorage(app);
    let folder;

    if (fileType === "choose_fileUrl") {
      folder = "choose_file/";
    }

    const fileName = new Date().getTime() + file.name;
    const storageRef = ref(storage, folder + fileName);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        if (fileType === "choose_fileUrl") {
          setChoose_filePerc(Math.round(progress));
        }
      },
      (error) => {
        console.log(error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setInputs((prev) => {
            return {
              ...prev,
              [fileType]: downloadURL,
            };
          });
        });
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const adsData = {
        choose_file: inputs.choose_fileUrl || data.choose_fileUrl,
        file_name: choose_file ? choose_file.name : data.file_name,
        client_name,
        web_link,
      };
      const response = await axios.put(
        `${Constant.BASE_URL}/help/update/${data._id}`,
        adsData
      );
      if (response.status === 200) {
        setChoose_file(undefined);
        setClient_name("");
        setWeb_link("");
        toast.success("Help updated successfully");

        setTimeout(() => {
          setEditPopup(false);
        }, 3000);
      } else {
        console.log("Failed to update form. Status:", response.status);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="popup-form">
      <div className="flex items-center justify-center w-full">
        <div className="p-4 px-2 py-3 bg-white rounded-md shadow-md lg:py-3 xl:py-3 2xl:p-4 ">
          <div className="lg:w-[300px] xl:w-[320px] 2xl:w-[420px] items-center justify-center">
            <div className="mb-4 text-lg font-semibold text-center 2xl:text-4xl ">
              Edit Help Service
            </div>
            <hr className="mt-1 " />
            <form onSubmit={handleSubmit}>
              <div className="flex flex-col items-center justify-center ">
                <div className="lg:py-5 xl:py-7 2xl:py-10 lg:text-[10px] xl:text-[13px] 2xl:text-[22px]">
                  <div className="flex text-gray-500 items-center justify-end py-3">
                    <label
                      htmlFor="choose_file"
                      className="flex flex-row text-gray-900 items-end flex-none px-3"
                    >
                      Thumbnail :
                      <span className="ml-1 text-red-500">*</span>
                    </label>
                    <div className="flex items-center lg:w-[180px] xl:w-[200px] 2xl:w-[250px]">
                      <label
                        htmlFor="choose_file"
                        className="flex items-center justify-center w-full mb-2 text-center border-b border-gray-500 outline-none cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap"
                      >
                        {choose_file
                          ? choose_file.name.length > 15
                            ? choose_file.name.substring(0, 15) + "..."
                            : choose_file.name
                          : data.file_name.length > 15
                            ? data.file_name.substring(0, 15) + "..."
                            : data.file_name}
                      </label>
                      <input
                        type="file"
                        id="choose_file"
                        name="choose_file"
                        className="hidden"
                        onChange={(e) =>
                          setChoose_file(e.target.files[0])
                        }
                        required={!data.file_name}
                      />
                    </div>
                    <div
                      className="h-full rounded-b-md bg-opacity-70 bg-[#FFB257] transition-width duration-100 ease-in-out"
                      style={{ width: `${choose_filePerc}%` }}
                    ></div>
                  </div>
                  <div className="flex items-center text-gray-500 justify-end py-3">
                    <label
                      htmlFor="client_name"
                      className="flex text-gray-900 items-end px-3"
                    >
                      Video Title:
                      <span className="ml-1 text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="client_name"
                      name="client_name"
                      className="flex items-start mb-2 border-b border-gray-500 outline-none lg:w-[180px] xl:w-[200px] 2xl:w-[250px] text-center"
                      placeholder="client name"
                      value={client_name}
                      onChange={(e) => setClient_name(e.target.value)}
                      required
                    />
                  </div>
                  <div className="flex items-center text-gray-500 justify-end py-3">
                    <label
                      htmlFor="web_link"
                      className="flex text-gray-900 items-end px-3"
                    >
                      Video Link:
                      <span className="ml-1 text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="web_link"
                      name="web_link"
                      className="flex items-start mb-2 border-b border-gray-500 outline-none lg:w-[180px] xl:w-[200px] 2xl:w-[250px] text-center"
                      placeholder="web link"
                      value={web_link}
                      onChange={(e) => setWeb_link(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div
                  className="py-4 button-container flex justify-center p-1 space-x-12 
                           lg:text-[10px] xl:text-[13px] 2xl:text-[22px]"
                >
                  <button
                    type="button"
                    onClick={() => {
                      setEditPopup(false);
                    }}
                    className="flex-shrink-0 px-3 py-1 bg-white shadow-md rounded-sm"
                    style={{
                      boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="flex-shrink-0 px-3 py-1 rounded-sm"
                    style={{
                      background:
                        "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                    }}
                  >
                    Upload
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditHelpForm;